import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchPaymentsList = createAsyncThunk(
  'customer_payments/fetchPaymentsList',
  async ({page, searchTerm=''} , { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/payments-list?page=${page}`, {searchTerm:searchTerm}
      );
      return response.data;  // Return videos data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const paymentsSlice = createSlice({
  name: 'admin_payments',
  initialState: {
    payments_list: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    errorMessage: ''
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder      
      // Handle get started videos
      .addCase(fetchPaymentsList.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchPaymentsList.fulfilled, (state, action) => {
        state.payments_list = action.payload.data.data;
        state.currentPage = action.payload.data.current_page;
        state.totalPages = action.payload.data.last_page;
        state.loading = false;
      })
      .addCase(fetchPaymentsList.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload ? action.payload.message : action.error.message;
      });    
  },
});

export const { clearMessage } = paymentsSlice.actions;

export default paymentsSlice.reducer;
